<mapfre-auditlib-select *ngIf="structureOrganizative" [form]="form" (onHide)="onHideHandler()"
    [selectionMode]="'multiple'" [field]="'txtName'" [data]="structureOrganizative" [label]="label"
    [placeholder]="'WORKS.CREATE.STEP1.SO_PLACEHOLDER'" (onChange)="keepData($event)" [sort]="false">
    <ng-template let-selectedItems #selectedItemsTemplate>
        <!--<div [ngClass]="{'custom-selected-item':selectedItem}" *ngFor="let selectedItem of selectedItems">
            <span class="color-white">{{selectedItem?.txtName}}</span>
            <i class="icon icon-16-px-cancelar color-white" (click)="onRemoveSelectedItem($event,selectedItem)"></i>
        </div>-->
        <div class="d-flex w-100 flex-column">
            <div [ngClass]="{'border-top': isFirst, 'custom-selected-item':selectedItem}" class="border-bottom"
                *ngFor="let selectedItem of selectedItems; let i = index; let isFirst = first;">
                <span class="ps-3 color-brown-grey">{{selectedItem?.txtName | translate}}</span>
                <span *ngIf="selectedItem && selectedItem.hours"
                    class="ps-3 color-brown-grey font-medium">{{selectedItem?.hours}}&nbsp;{{'PLANNING.PAI.ACTIVITY.ASSIGNED_HOURS' | translate}}
                </span>
            </div>
            <div *ngIf="!selectedItems" translate>
                WORKS.CREATE.STEP1.SO_PLACEHOLDER
            </div>
        </div>
    </ng-template>
    <ng-template let-item #itemTemplate>
        <div class="d-flex align-items-center justify-content-between w-100">
            <span class="ellipsis">{{item.txtName | translate}}</span>
            <div class="w-44 noSpace" *ngIf="isOptionSelected(item)" (click)="stopPropagation($event)">
                <mapfre-auditlib-input class="custom-input-assigned-hours" [inline]="true"
                    (modelChange)="setWeight(item,$event)" [model]="item.hours"
                    label="{{'WORKS.CREATE.STEP1.SO_LABEL' | translate}}">
                </mapfre-auditlib-input>
            </div>
        </div>
    </ng-template>
</mapfre-auditlib-select>